var _path, _ellipse, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFileCheck = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.88507 0C0.942531 0 0 0.890574 0 2.55111L6.43252e-06 16.5822C6.43252e-06 17.3111 0.323432 18.2222 1.88507 18.2222H13.1954C14.7571 18.2222 15.0805 17.7667 15.0805 16.5822V6.37777C15.0805 2.50319 13.0691 0 9.42532 0H1.88507ZM1.88507 0.911111H9.42532V5.46666H14.138V16.5822C14.138 17.1357 13.716 17.3111 13.1954 17.3111H1.88507C1.36452 17.3111 0.942538 17.1357 0.942538 16.5822V2.55111C0.942531 1.36667 1.36452 0.911111 1.88507 0.911111ZM10.3679 0.911111C11.8866 1.23892 13.6667 2.27778 14.138 4.55555H10.3679V0.911111Z",
    fill: "#D4DDF0"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.3365,
    cy: 16.326,
    rx: 3.33332,
    ry: 3.33332,
    fill: "#45B23B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0989 17.2881L13.1139 16.386L13.4422 16.0854L14.0989 16.6867L15.4122 15.484L15.7405 15.7847L14.0989 17.2881Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFileCheck);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/fileCheck.6efe7d4cb0c13bd549c5239312e20b88.svg";